import { useTranslation as useI18nextTranslation } from 'react-i18next';
import type { i18n as I18nInstance } from 'i18next';

type AppT = (key: string, options?: Record<string, string | number>) => string;

/** Typed wrapper so `t()` accepts any app translation key without strict i18next resource generics. */
export function useTranslation(): {
  t: AppT;
  i18n: I18nInstance;
  ready: boolean;
} {
  const result = useI18nextTranslation();
  return {
    t: result.t as AppT,
    i18n: result.i18n,
    ready: result.ready,
  };
}
